<template>
  <div class="home_main">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" height="200">
      <van-swipe-item v-for="item,index in bannerList" :key="index" @click="goToDetail(item)">
        <van-image :src="imgBaseUrl + item.cover"/>
      </van-swipe-item>
    </van-swipe>
    <van-grid :column-num="4" class="my_grid" :border="false">
      <van-grid-item key="property" icon="wap-home-o" text="社区通知" @click="goList('property')"/>
      <!-- <van-grid-item key="trade" icon="shop-o" text="商业信息" @click="goList('trade')"/> -->
      <van-grid-item key="tissue" icon="cluster-o" text="红色组织" @click="goList('tissue')"/>
      <van-grid-item key="notice" icon="comment-o" text="社区新闻" @click="goList('notice')"/>
      <van-grid-item key="news" icon="friends-o" text="社区公告" @click="goList('news')"/>
      <!-- <van-grid-item key="wu" text="" /> -->
    </van-grid>
    <div class="new_list_body">
      <div class="new_list_title">
        最近通知
      </div>
      <div v-for="item,index in newslist" :key="index" class="news_list_item" @click="goToDetail(item)">
        <van-row>
          <van-col :span="7">
            <van-image :src="imgBaseUrl + item.cover" width="100" height="100" :error-icon="backImg"></van-image>
          </van-col>
          <van-col :span="17">
            <div style="height: 100px">
              <div style="height: 33%;line-height: 33px;">
                <span style="font-weight: bold;">通知类型</span>：{{getTypeName(item.type)}}
              </div>
              <div style="height: 33%;line-height: 33px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                <span style="font-weight: bold;">通知标题</span>：{{item.title}}
              </div>
              <div style="height: 33%;line-height: 33px;">
                <span style="font-weight: bold;">发布时间</span>：{{item.createTime}}
              </div>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <div style="height: 50px;"></div>
    <!-- <van-tabbar v-model="active">
      <van-tabbar-item icon="home-o" to="/">通知中心</van-tabbar-item>
      <van-tabbar-item icon="search" to="/mine/home">我的</van-tabbar-item>
    </van-tabbar> -->
  </div>
</template>

<script>
import local from '@/utils/local'
import config from '@/config';
import backImg from "@/assets/images/R-C.jpg";
import {newsPage} from '@/api/news'
export default {
  data() {
    return {
      backImg: backImg,
      active: 0,
      imgBaseUrl: config.imgBaseUrl,
      newslist: [],
      bannerList: [],
      loading: false,
      finished: true,
      token: ''
    }
  },
  created(){
    local.set('t_k',"111111111111111111")
    this.token = local.get('t_k')
    this.getnewsList();
    this.getnewsBanner();
  },
  methods: {
    getTypeName(type){
      if (type == 'property') {
        return '社区通知'
      }else if (type == 'trade') {
        return '商业信息'
      }else if (type == 'tissue') {
        return '红色组织'
      }else if (type == 'notice') {
        return '社区新闻'
      }else if (type == 'news') {
        return '社区公告'
      }
    },
    getnewsBanner(){
      newsPage({
        types: 'notice,tissue,trade,property',
        hasCover: 1,
        pageSize: 5,
        pageNum: 1
      }).then(res=>{
        if (res) {
          this.bannerList = res.data.records;
        }
      })
    },
    getnewsList(){
      newsPage({
        types: 'notice,tissue,trade,property',
        pageSize: 10,
        pageNum: 1
      }).then(res=>{
        if (res) {
          this.newslist = res.data.records;
        }
      })
    },
    goToDetail(item){
      this.$router.push({
        path: '/news/inDetail',
        query: {
          type: item.type,
          id: item.id
        }
      })
    },
    goList(type){
      this.$router.push({
        path: '/news/list',
        query: {
          type: type,
        }
      })
    }
  },
}
</script>
<style scoped>
.news_list_item{
  padding: 8px;
  border-bottom: 1px solid #cecece;;
}
.new_list_body{
  background-color: #fff;
  margin-top: 8px;
}
.new_list_title{
  font-weight: bold;
  color: #1989fa;
  padding: 8px 0px 8px 12px;
  border-bottom: 2px solid #cecece;;
}
</style>
<style>
.van-icon__image{
  width: 100px;
  height: 100px;
}
.home_main{
  background-color: #eeecec;
}
/* .my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
} */
.my_grid{
  margin-top: 8px;
}
</style>
